/* eslint-disable no-throw-literal */
import React, { Component } from 'react';
import * as GServ from '../services/GatewayService';
import { CircularProgress,Button,TextField } from '@material-ui/core';

const Today = new Date();

function gimmeDOB(YearsOld){
    const toDay = new Date();
    const myDOB = (toDay.getFullYear() - YearsOld) + "-" + pad(toDay.getMonth() + 1,2,"0")  + "-" + pad(toDay.getDate(),2,"0");
    return myDOB;
}

function pad(str,width,char){
    var myStr = str.toString();
    while (myStr.length<width){
      myStr = char + myStr; 
    }
    return myStr;
}
  

function parseID(idNumber) {
    // first clear any left over error messages

    //Kill at source if not 13 digits
    if (idNumber.length !== 13){
        return {Result : "Failed"};
    }

    // assume everything is correct and if it later turns out not to be, just set this to false
    var correct = true;
    var idParse = {};

    // get first 6 digits as a valid date
    var tempDate = new Date(idNumber.substring(0, 2), idNumber.substring(2, 4)-1, idNumber.substring(4, 6));
    var id_date = tempDate.getDate();
    var id_month = tempDate.getMonth();
  
    var id_year = tempDate.getFullYear();
    const thisYear = Today.getFullYear();

    if((thisYear - id_year)>=100){
      tempDate.setFullYear(tempDate.getFullYear()+100);
      id_year = tempDate.getFullYear()
    }

    // eslint-disable-next-line eqeqeq
    if (!((tempDate.getFullYear().toString().substring(2,4) == idNumber.substring(0, 2)) && (id_month == idNumber.substring(2, 4) - 1) && (id_date == idNumber.substring(4, 6)))) {
        // console.log('Date failed');
        correct = false;
    }

    // get the gender
    var genderCode = idNumber.substring(6, 10);
    var gender = parseInt(genderCode) < 5000 ? "Female" : "Male";

    // get country ID for citzenship
    var citzenship = parseInt(idNumber.substring(10, 11)) === 0 ? "Yes" : "No";

    // apply Luhn formula for check-digits
    var tempTotal = 0;
    var checkSum = 0;
    var multiplier = 1;
    for (var i = 0; i < 13; ++i) {
        tempTotal = parseInt(idNumber.charAt(i)) * multiplier;
        if (tempTotal > 9) {
            tempTotal = parseInt(tempTotal.toString().charAt(0)) + parseInt(tempTotal.toString().charAt(1));
        }
        checkSum = checkSum + tempTotal;
        multiplier = (multiplier % 2 === 0) ? 1 : 2;
    }
    if ((checkSum % 10) !== 0) {
        correct = false;
    };

    //advance DOB by 12 hours to eliminate issue with timezones...
    tempDate.setHours(tempDate.getHours()+12);

    // if no error found, hide the error message
    if (correct) {
        idParse = {
          id_number : idNumber,
          Result : "Success",
          date_of_birth : tempDate,
          gender : gender,
          sa_citizen : citzenship
        };
    }
    // otherwise, show the error
    else {
        idParse = {
          Result : "Failed"        
        };
    }

    return idParse;
}


const initial_state = {
    showSpinner: false,
    showInput: true,
    status: '',
    warning: '',
    id_value: '',
    said: true,
    fid: false,
    fp: false,
    f_nation: '',
    gender: 'Male',
    sa_citizen: null,
    dob: '',
    id_pholder: 'South African ID Number',
    id_title: '13 digits with no spaces e.g. 7704235061083',
    id_pattern: '[0-9]{13}',
    canSubmit: true,
    submitting: false,
    user_choice_retry: true,
}


class IDNum extends Component {
    constructor(props) {
        super(props);
        this.state = initial_state;
    }
    
    render() {
        return (
            <div>
                
                {this.state.showInput&&
                <div>
                    <h3>Identity Number</h3>
                    <p>In order to process your {this.props.operation==='register'? 'registration' : 'application'} and to check on the status of any existing {this.props.operation==='register'? 'registrations' : 'applications'} you may have with us, we need a few official details...</p>
                    <form name="IDNum" method="POST" onSubmit={this.submitHandler}>
                        
                        {!this.props.require_said&&
                        <div>
                            <span id="said_span">Do you have a South African Identity Number?&nbsp;&nbsp;</span>
                            <input type="radio" disabled={this.state.submitting} name='said_select' id="Yes" value='said_selected' onChange={this.fieldHandler} checked={this.state.said}/><label htmlFor="Yes">Yes</label>&nbsp;&nbsp;
                            <input type="radio" disabled={this.state.submitting} name='said_select' id="No" value='no_said' onChange={this.fieldHandler} checked={!this.state.said}/><label htmlFor="No">No</label>
                        </div>}

                        {this.props.require_said&&
                        <div>
                            <span id="said_span">A valid South African Identity Number is required</span>
                        </div>}
                    
                        {!this.state.said&&
                        <div>
                            <hr/>
                            <span id="said_span" style={{color:'#006e7a', marginTop:'15px', marginBottom:'15px'}}>Please provide foreign identification details - &nbsp;&nbsp;</span>
                            <div style={{textAlign:'left',marginLeft:'25%', marginTop:'15px'}}>
                                <div style={{marginTop:'10px'}} >Nationality?&nbsp;
                                    <select className='spec_inputs' style={{fontSize:'18px'}} id="nationality" name="nationality" disabled={this.state.submitting} value={this.state.f_nation} onChange={this.fieldHandler} required>
                                        <option value="">-- select one --</option>
                                        <option value="afghan">Afghan</option>
                                        <option value="albanian">Albanian</option>
                                        <option value="algerian">Algerian</option>
                                        <option value="american">American</option>
                                        <option value="andorran">Andorran</option>
                                        <option value="angolan">Angolan</option>
                                        <option value="antiguans">Antiguans</option>
                                        <option value="argentinean">Argentinean</option>
                                        <option value="armenian">Armenian</option>
                                        <option value="australian">Australian</option>
                                        <option value="austrian">Austrian</option>
                                        <option value="azerbaijani">Azerbaijani</option>
                                        <option value="bahamian">Bahamian</option>
                                        <option value="bahraini">Bahraini</option>
                                        <option value="bangladeshi">Bangladeshi</option>
                                        <option value="barbadian">Barbadian</option>
                                        <option value="barbudans">Barbudans</option>
                                        <option value="batswana">Batswana</option>
                                        <option value="belarusian">Belarusian</option>
                                        <option value="belgian">Belgian</option>
                                        <option value="belizean">Belizean</option>
                                        <option value="beninese">Beninese</option>
                                        <option value="bhutanese">Bhutanese</option>
                                        <option value="bolivian">Bolivian</option>
                                        <option value="bosnian">Bosnian</option>
                                        <option value="brazilian">Brazilian</option>
                                        <option value="british">British</option>
                                        <option value="bruneian">Bruneian</option>
                                        <option value="bulgarian">Bulgarian</option>
                                        <option value="burkinabe">Burkinabe</option>
                                        <option value="burmese">Burmese</option>
                                        <option value="burundian">Burundian</option>
                                        <option value="cambodian">Cambodian</option>
                                        <option value="cameroonian">Cameroonian</option>
                                        <option value="canadian">Canadian</option>
                                        <option value="cape verdean">Cape Verdean</option>
                                        <option value="central african">Central African</option>
                                        <option value="chadian">Chadian</option>
                                        <option value="chilean">Chilean</option>
                                        <option value="chinese">Chinese</option>
                                        <option value="colombian">Colombian</option>
                                        <option value="comoran">Comoran</option>
                                        <option value="congolese">Congolese</option>
                                        <option value="costa rican">Costa Rican</option>
                                        <option value="croatian">Croatian</option>
                                        <option value="cuban">Cuban</option>
                                        <option value="cypriot">Cypriot</option>
                                        <option value="czech">Czech</option>
                                        <option value="danish">Danish</option>
                                        <option value="djibouti">Djibouti</option>
                                        <option value="dominican">Dominican</option>
                                        <option value="dutch">Dutch</option>
                                        <option value="east timorese">East Timorese</option>
                                        <option value="ecuadorean">Ecuadorean</option>
                                        <option value="egyptian">Egyptian</option>
                                        <option value="emirian">Emirian</option>
                                        <option value="equatorial guinean">Equatorial Guinean</option>
                                        <option value="eritrean">Eritrean</option>
                                        <option value="estonian">Estonian</option>
                                        <option value="ethiopian">Ethiopian</option>
                                        <option value="fijian">Fijian</option>
                                        <option value="filipino">Filipino</option>
                                        <option value="finnish">Finnish</option>
                                        <option value="french">French</option>
                                        <option value="gabonese">Gabonese</option>
                                        <option value="gambian">Gambian</option>
                                        <option value="georgian">Georgian</option>
                                        <option value="german">German</option>
                                        <option value="ghanaian">Ghanaian</option>
                                        <option value="greek">Greek</option>
                                        <option value="grenadian">Grenadian</option>
                                        <option value="guatemalan">Guatemalan</option>
                                        <option value="guinea-bissauan">Guinea-Bissauan</option>
                                        <option value="guinean">Guinean</option>
                                        <option value="guyanese">Guyanese</option>
                                        <option value="haitian">Haitian</option>
                                        <option value="herzegovinian">Herzegovinian</option>
                                        <option value="honduran">Honduran</option>
                                        <option value="hungarian">Hungarian</option>
                                        <option value="icelander">Icelander</option>
                                        <option value="indian">Indian</option>
                                        <option value="indonesian">Indonesian</option>
                                        <option value="iranian">Iranian</option>
                                        <option value="iraqi">Iraqi</option>
                                        <option value="irish">Irish</option>
                                        <option value="israeli">Israeli</option>
                                        <option value="italian">Italian</option>
                                        <option value="ivorian">Ivorian</option>
                                        <option value="jamaican">Jamaican</option>
                                        <option value="japanese">Japanese</option>
                                        <option value="jordanian">Jordanian</option>
                                        <option value="kazakhstani">Kazakhstani</option>
                                        <option value="kenyan">Kenyan</option>
                                        <option value="kittian and nevisian">Kittian and Nevisian</option>
                                        <option value="kuwaiti">Kuwaiti</option>
                                        <option value="kyrgyz">Kyrgyz</option>
                                        <option value="laotian">Laotian</option>
                                        <option value="latvian">Latvian</option>
                                        <option value="lebanese">Lebanese</option>
                                        <option value="liberian">Liberian</option>
                                        <option value="libyan">Libyan</option>
                                        <option value="liechtensteiner">Liechtensteiner</option>
                                        <option value="lithuanian">Lithuanian</option>
                                        <option value="luxembourger">Luxembourger</option>
                                        <option value="macedonian">Macedonian</option>
                                        <option value="malagasy">Malagasy</option>
                                        <option value="malawian">Malawian</option>
                                        <option value="malaysian">Malaysian</option>
                                        <option value="maldivan">Maldivan</option>
                                        <option value="malian">Malian</option>
                                        <option value="maltese">Maltese</option>
                                        <option value="marshallese">Marshallese</option>
                                        <option value="mauritanian">Mauritanian</option>
                                        <option value="mauritian">Mauritian</option>
                                        <option value="mexican">Mexican</option>
                                        <option value="micronesian">Micronesian</option>
                                        <option value="moldovan">Moldovan</option>
                                        <option value="monacan">Monacan</option>
                                        <option value="mongolian">Mongolian</option>
                                        <option value="moroccan">Moroccan</option>
                                        <option value="mosotho">Mosotho</option>
                                        <option value="motswana">Motswana</option>
                                        <option value="mozambican">Mozambican</option>
                                        <option value="namibian">Namibian</option>
                                        <option value="nauruan">Nauruan</option>
                                        <option value="nepalese">Nepalese</option>
                                        <option value="new zealander">New Zealander</option>
                                        <option value="ni-vanuatu">Ni-Vanuatu</option>
                                        <option value="nicaraguan">Nicaraguan</option>
                                        <option value="nigerien">Nigerien</option>
                                        <option value="north korean">North Korean</option>
                                        <option value="northern irish">Northern Irish</option>
                                        <option value="norwegian">Norwegian</option>
                                        <option value="omani">Omani</option>
                                        <option value="pakistani">Pakistani</option>
                                        <option value="palauan">Palauan</option>
                                        <option value="panamanian">Panamanian</option>
                                        <option value="papua new guinean">Papua New Guinean</option>
                                        <option value="paraguayan">Paraguayan</option>
                                        <option value="peruvian">Peruvian</option>
                                        <option value="polish">Polish</option>
                                        <option value="portuguese">Portuguese</option>
                                        <option value="qatari">Qatari</option>
                                        <option value="romanian">Romanian</option>
                                        <option value="russian">Russian</option>
                                        <option value="rwandan">Rwandan</option>
                                        <option value="saint lucian">Saint Lucian</option>
                                        <option value="salvadoran">Salvadoran</option>
                                        <option value="samoan">Samoan</option>
                                        <option value="san marinese">San Marinese</option>
                                        <option value="sao tomean">Sao Tomean</option>
                                        <option value="saudi">Saudi</option>
                                        <option value="scottish">Scottish</option>
                                        <option value="senegalese">Senegalese</option>
                                        <option value="serbian">Serbian</option>
                                        <option value="seychellois">Seychellois</option>
                                        <option value="sierra leonean">Sierra Leonean</option>
                                        <option value="singaporean">Singaporean</option>
                                        <option value="slovakian">Slovakian</option>
                                        <option value="slovenian">Slovenian</option>
                                        <option value="solomon islander">Solomon Islander</option>
                                        <option value="somali">Somali</option>
                                        {/* <!-- <option value="south african">South African</option> --> */}
                                        <option value="south korean">South Korean</option>
                                        <option value="spanish">Spanish</option>
                                        <option value="sri lankan">Sri Lankan</option>
                                        <option value="sudanese">Sudanese</option>
                                        <option value="surinamer">Surinamer</option>
                                        <option value="swazi">Swazi</option>
                                        <option value="swedish">Swedish</option>
                                        <option value="swiss">Swiss</option>
                                        <option value="syrian">Syrian</option>
                                        <option value="taiwanese">Taiwanese</option>
                                        <option value="tajik">Tajik</option>
                                        <option value="tanzanian">Tanzanian</option>
                                        <option value="thai">Thai</option>
                                        <option value="togolese">Togolese</option>
                                        <option value="tongan">Tongan</option>
                                        <option value="trinidadian or tobagonian">Trinidadian or Tobagonian</option>
                                        <option value="tunisian">Tunisian</option>
                                        <option value="turkish">Turkish</option>
                                        <option value="tuvaluan">Tuvaluan</option>
                                        <option value="ugandan">Ugandan</option>
                                        <option value="ukrainian">Ukrainian</option>
                                        <option value="uruguayan">Uruguayan</option>
                                        <option value="uzbekistani">Uzbekistani</option>
                                        <option value="venezuelan">Venezuelan</option>
                                        <option value="vietnamese">Vietnamese</option>
                                        <option value="welsh">Welsh</option>
                                        <option value="yemenite">Yemenite</option>
                                        <option value="zambian">Zambian</option>
                                        <option value="zimbabwean">Zimbabwean</option>
                                    </select>
                                </div>
                                <div style={{marginTop:'10px'}}>Gender&nbsp;&nbsp;
                                    <input type="radio" disabled={this.state.submitting} name='gender_select' id="Male" value='Male' onChange={this.fieldHandler} checked={this.state.gender==='Male'?true:false}/><label htmlFor="Male">Male</label>&nbsp;&nbsp;
                                    <input type="radio" disabled={this.state.submitting} name='gender_select' id="Female" value='Female' onChange={this.fieldHandler} checked={this.state.gender==='Female'?true:false}/><label htmlFor="Female">Female</label>
                                </div>
                                <div style={{marginTop:'10px'}}>Date of Birth&nbsp;&nbsp;
                                    <input className='spec_inputs' style={{textAlign:'center'}} disabled={this.state.submitting} autoComplete="off" type="date" id="dob" name='dob' value={this.state.dob} onChange={this.fieldHandler} required/>
                                </div>
                                <br/>
                                <span id="fid_span">
                                    <input type="radio" name='foreign_select' id="fid" value='fid_selected' onChange={this.fieldHandler} disabled={this.state.submitting} />
                                    <label htmlFor="fid"> Foreign National Identity Number?</label>&nbsp;&nbsp;
                                </span><br/>
                                <span id="fid_span">
                                    <input type="radio" name='foreign_select' id="fp" value='fp_selected' onChange={this.fieldHandler} disabled={this.state.submitting} />
                                    <label htmlFor="fp"> Foreign Passport Number?</label>&nbsp;&nbsp;
                                </span><br/>    
                            </div>
                        </div>}

                        <TextField
                            variant='outlined'
                            name='unique_id'
                            disabled={!this.state.canSubmit}
                            label={this.state.id_pholder}
                            value={this.state.id_value}
                            // onFocus={()=> this.setState({id_pholder:'',status:'', warning:''})}
                            // onBlur={this.setPlaceholder} pattern={this.state.id_pattern}
                            onChange={this.fieldHandler} 
                            required
                            title={this.state.id_title}
                            autoComplete='off'
                            autoCorrect='off'
                            autoCapitalize='off'
                            autoFocus={true}
                            style={{width:'40%', minWidth:'250px', marginTop:'15px'}}
                        />

                        <br/>
                        {/* <div className="prime_input" >
                            <input name='unique_id' disabled={!this.state.canSubmit} placeholder={this.state.id_pholder} value={this.state.id_value} onFocus={()=> this.setState({id_pholder:'',status:'', warning:''})} onChange={this.fieldHandler} onBlur={this.setPlaceholder} pattern={this.state.id_pattern} required title={this.state.id_title} autoComplete='off' autoCorrect='off' autoCapitalize='off' />
                        </div> */}

                        <Button
                            variant='contained'
                            size='large'
                            color='primary'
                            id="Submit"
                            disabled={!this.state.canSubmit}
                            type='submit'
                            style={{marginTop:'15px'}}
                        >
                            <span id="s1" >Submit</span>
                        </Button>
                        {/* <button id="Submit" className="button" style={{verticalAlign:'middle',marginTop:'15px'}} disabled={!this.state.canSubmit}><span id="s1" >Submit</span></button> */}
                    
                    </form>
                </div>}

                {!this.state.showInput&&
                <div>
                    <h3>Duplicate Identity Number: <b>{this.state.id_value}</b></h3>
                    <p>The {this.state.said? "South African Identity": this.state.f_nation + this.state.fid? "Identity" : "Passport"} Number you've entered is already on our system, <i>however it appears to belong to someone else...</i></p>
                    <span id="said_span" style={{color:'#006e7a'}}>Please select an option below, in order to proceed...&nbsp;&nbsp;</span>
                    <br/><br/>
                    <div style={{color:this.state.user_choice_retry? 'blue' : 'inherit'}}>
                        <input type="radio" disabled={this.state.submitting} name='user_choice' id="A" value='retry' onChange={this.fieldHandler} checked={this.state.user_choice_retry}/><label htmlFor="A">I've entered the incorrect {this.state.f_nation + this.state.fid? "Identity" : "Passport"} Number, and will re-enter the correct one.</label>&nbsp;&nbsp;
                    </div>
                    <br/>
                    <div style={{color:this.state.user_choice_retry? 'inherit' : 'red'}}>
                        <input type="radio" disabled={this.state.submitting} name='user_choice' id="B" value='confirm' onChange={this.fieldHandler} checked={!this.state.user_choice_retry}/><label htmlFor="B">This is definitely <b><u>my</u></b> {this.state.f_nation + this.state.fid? "Identity" : "Passport"} Number, and it should not be associated with anyone else!</label>
                    </div>
                    <br/><br/>

                    <Button
                        variant='contained'
                        size='large'
                        color='primary'
                        id="Submit"
                        type='submit'
                        onClick={this.handleUserChoice}
                        disabled={!this.state.canSubmit}
                        style={{marginTop:'15px'}}
                    >
                        <span id="s2" >Submit</span>
                    </Button>
                    {/* <button id="Submit" className="button" style={{verticalAlign:'middle'}} onClick={this.handleUserChoice} disabled={!this.state.canSubmit}><span id="s2" >Submit</span></button> */}
                </div>}

                <hr/>
                <span id="StatusBar" className="StatusBar">
                    {this.state.showSpinner&&<CircularProgress size={30} />}&nbsp;&nbsp;
                    {this.state.status}
                </span>
                <span className='warningMessage'>{this.state.warning}</span>
            </div>
        );

    }
    
    submitHandler = (e) => {
        e.preventDefault();
        //validate email here...
        this.setState({showSpinner:true,canSubmit:false,submitting:true, status:'Processing...'});
        try{

            var myDob = new Date(this.state.dob);
            var sa_citizen = this.state.sa_citizen;
            var gender = this.state.gender;

            if (this.state.said) {
                const idObj = parseID(this.state.id_value);
                // console.log('idObj',idObj);
                if (idObj.Result!=="Success"){throw Error('The number entered does not appear to be a valid South African Identity Number. Please re-enter carefully.')}
                myDob = idObj.date_of_birth;
                sa_citizen = idObj.sa_citizen==='Yes'?true:false;
                gender = idObj.gender;
                this.setState({dob:myDob,gender:gender,sa_citizen:sa_citizen});
            } 

            //Do date diff calculations here now...
            const minDob = new Date(gimmeDOB(this.props.form_max_age));
            const maxDob = new Date(gimmeDOB(this.props.form_min_age));

            if (myDob>maxDob){throw Error((this.state.said?'ID Number ':'Date of Birth ')+'provided indicates applicant is under minimum age. Please contact us if this appears incorrect.')}
            if (myDob<minDob){throw Error((this.state.said?'ID Number ':'Date of Birth ')+'provided indicates applicant is over maximum qualifying age. Please contact us if this appears incorrect.')}
            
            this.setState({warning:''});

            const dataObj = {
                unique_id: this.state.id_value,
                unique_id_type: (this.state.said)? "said" : (this.state.fp)? 'fp' : 'fid',
                gender: gender,
                date_of_birth: myDob,
                sa_citizen: sa_citizen,
                fname: this.props.fname,
                lname: this.props.lname,
                mobile: this.props.mobile
            };

            if (this.state.fp||this.state.fid){dataObj.unique_id_nationality = this.state.f_nation}

            // console.log('Ok! now to run Gserv update request...',dataObj);
            // now run Gserv update request...
            GServ.id_obj_submit(this.props.gwt,dataObj)
            .then(subReply => {
                // console.log('subReply',subReply);
                if (subReply.Result!=="Success"){throw subReply.Message;}

                //Deal with routing based on Directive received...
                switch (subReply.Directive) {
                    case "cleared for launch":
                        this.props.setParentState({showIDNum:false,showMainForm:true}); 
                        break;

                    case "existing email - same name":
                        // console.log('Need to handle duplicate email - same name (i.e. there seems to have been an email change...)')
                        this.props.setParentState({showIDNum:false,showIDDuplicateDialog:true,old_email:subReply.old_email,old_mobile:subReply.old_mobile,old_name_same:true,id_obj:
                            {
                                unique_id : dataObj.unique_id,
                                unique_id_type : dataObj.unique_id_type,
                                unique_id_nationality : dataObj.unique_id_nationality
                            },
                            mobile_match:subReply.mobile_match,
                            old_user_token:subReply.old_user_token
                        });

                        break;

                    case "existing email - name mismatch":
                        // console.log('Need to handle duplicate email - different name (i.e. somethings wrong here - different person...)');
                        this.props.setParentState({old_name_same:false,id_obj:
                            {
                                unique_id : dataObj.unique_id,
                                unique_id_type : dataObj.unique_id_type,
                                unique_id_nationality : dataObj.unique_id_nationality
                            }
                        });

                        this.setState({showInput:false,canSubmit:true,submitting:false,showSpinner:false,status:'',warning:''});
                        break;
                
                    default:
                        throw 'Invalid Directive received from server';
                }

            }).catch(err => {
                console.log('Error caught @ return from Gserv.name_num_submit => ',err);
                this.setState({status:'',warning:'There was an error processing your entry. If this problem persists, please contact us.',showSpinner:false,canSubmit:true});
            });

        } catch (err) {
            console.log('Error caught @ submitHandler => ', err.message);
            this.setState({warning:err.message,status:'',submitting:false,canSubmit:true,showSpinner:false});
        }

    }

    fieldHandler = (e) => {
        // console.log('change on ', e.target.name, e.target.value);
        
        if (e.target.name==='dob'){
            this.setState({dob:e.target.value});
        }

        if (e.target.name==='nationality'){
            this.setState({f_nation:e.target.value});
        }

        if (e.target.name==='unique_id'){
            this.setState({id_value: e.target.value.toUpperCase()});
        }

        if (e.target.name==='said_select'){
            if (e.target.value==='said_selected'){
                this.setState({said:true,fid:false,fp:false,id_value:'',canSubmit:true, id_pholder:'South African ID Number',id_title:'13 digits with no spaces e.g. 7704235061083',id_pattern:'[0-9]{13}'});
            } else {
                this.setState({said:false, fid:false,fp:false, id_value:'',sa_citizen:false,canSubmit:false,id_pholder:'select foreign id type',id_title:''})
            }
        }

        if (e.target.name==='gender_select'){
            this.setState({gender:e.target.value})
        }
        
        if (e.target.name==='foreign_select'){
            if (e.target.value==='fid_selected'){
                this.setState({fid:true,fp:false,id_pholder:'Foreign ID Number',canSubmit:true,id_title:'National identity number (non-South African) - alpha-numeric (uppercase letters only) with no spaces, minimum length',id_pattern:'[A-Z,0-9]{5,}'});
            } else if (e.target.value==='fp_selected'){
                this.setState({fid:false,fp:true,id_pholder:'Foreign Passport Number',canSubmit:true,id_title:'Foreign passport number - alpha-numeric (uppercase letters only) with no spaces, minimum length',id_pattern:'[A-Z,0-9]{5,}'});
            }
        }

        if (e.target.name==='user_choice'){
            if (e.target.value==='retry'){
                this.setState({user_choice_retry:true});
            } else {
                this.setState({user_choice_retry:false});
            }
        }

    }
    
    setPlaceholder = () => {
        // console.log('called set placeholder...');
        // console.log('State: ',this.state);
        if (!this.state.said&&!this.state.fp&&!this.state.fid){
            this.setState({id_pholder:'select foreign id type'})
        } else {
            if (this.state.said){this.setState({id_pholder:'South African ID Number',id_title:'13 digits with no spaces e.g. 7704235061083',id_pattern:'[0-9]{13}'})}
            if (this.state.fid){this.setState({id_pholder:'Foreign ID Number',id_title:'National identity number (non-South African) - alpha-numeric (uppercase letters only) with no spaces, minimum length',id_pattern:'[A-Z,0-9]{5,}'})}
            if (this.state.fp){this.setState({id_pholder:'Foreign Passport Number',id_title:'Foreign passport number - alpha-numeric (uppercase letters only) with no spaces, minimum length',id_pattern:'[A-Z,0-9]{5,}'})}
        }
    }

    handleUserChoice = () => {
        // console.log('Pressed S2...');
        // console.log('User choice to retry? ',this.state.user_choice_retry);
        if (this.state.user_choice_retry){
            //reset form and try again...
            this.setState(initial_state);
        } else {
            //Go to regret page and log attempt
            this.props.setParentState({showIDNum:false,showRegret:true});
        }
    }

}

export default IDNum;